'use client'
import {
  ContentfulConfig
} from "./chunk-4T365VQK.mjs";

// src/api/locale.ts
var REGEIONS = {
  en: "-US",
  ar: "-SA",
  fr: ""
};
var getContentfulSafeLocale = (locale) => {
  var _a, _b, _c;
  const supportedLngs = ((_a = ContentfulConfig.config) == null ? void 0 : _a.supportLocales) || [];
  const defaultLocale = (supportedLngs == null ? void 0 : supportedLngs[0]) || "en";
  if (!locale) {
    return defaultLocale + REGEIONS[defaultLocale];
  }
  const lang = (_c = (_b = locale == null ? void 0 : locale.split("-")) == null ? void 0 : _b[0]) == null ? void 0 : _c.toLowerCase();
  const safeLang = supportedLngs.includes(lang) ? lang : "en";
  const region = REGEIONS[safeLang] || "";
  const fullLang = safeLang + region;
  return fullLang;
};

export {
  getContentfulSafeLocale
};
//# sourceMappingURL=chunk-IIMDQLWJ.mjs.map